import { RowData } from '@tanstack/react-table';

/** internal columns which aren't used in a canonical document */
export enum ColumnTypesInternal {
  procuros_select = 'procuros_select',
  procuros_delete = 'procuros_delete',
  procuros_added = 'procuros_added',
  procuros_index = 'procuros_index',
  procuros_collapse = 'procuros_collapse',
  /**
   * A read-only audit-log display column (Product Masterdata's "Log" column is the first
   * consumer). This needs to be a member of this enum, not a page-local string: `useBulkActions`
   * excludes every `type in ColumnTypesInternal` column from bulk-edit eligibility
   * (`useBulkActions.ts`), which is exactly the exclusion a display-only column needs if
   * `selectableRows` is ever turned on for a table that has one.
   */
  procuros_log = 'procuros_log',
}

/** A column's requirement state, derived from a field's spec modality. */
export type ColumnRequirement = 'required' | 'conditional' | 'optional';

export type WebEDIRowData = {
  _internal?: {
    level?: number;
    /** JSONPath reference to the parent line item, e.g. `$['line_items'][0]`. Set by datachecks for sub-items. */
    parent_line_item?: string;
    /** JSONPath reference to the parent transport unit, e.g. `$['transport_units'][0]`. */
    parent_transport_unit?: string;
    [ColumnTypesInternal.procuros_added]?: boolean;
  };
} & Record<string, unknown> &
  RowData;
